import type { Redirect } from "@/login/types";
import { computed } from "vue";

export function useRedirectTargets(redirect: Redirect) {
  const redirectTarget = computed(() => {
    switch (redirect?.redirectTarget) {
      case "participationRequest": {
        return {
          name: redirect.redirectTarget,
          params: { canvassId: redirect.canvassId },
        };
      }
      default: {
        return null;
      }
    }
  });

  return redirectTarget;
}
